export default __webpack_public_path__ + "asset/croatia.97af83aae28efe9f7b9d85060d4ab9ad.svg";